import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import GroheMobileFooterButtons from "./groheMobileFooterButtons";
import LookWizardContentButtons from "../../lookNavigation/lookMain/lookWizard/lookWizardContentButtons";

const GroheMobileFooter = (props) => {

  const {lookOpened, wizardActiveItem} = props;

  return (
    <div className={"gm-footer" + (lookOpened || wizardActiveItem ? " gm-footer--opened" : "")}>
      {wizardActiveItem ? <LookWizardContentButtons/> : <GroheMobileFooterButtons/>}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened} = store.lookState;
  const {wizardActiveItem} = store.wizardState;
  return {
    lookOpened,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheMobileFooter)
);
